import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const CallHall = styled.div`
  > .header {
    height: 20rem;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;

    > .content {
      padding: 3rem;
      position: relative;
      z-index: 10;
      > .name {
        color: #fff;
        font-size: 2.7rem;

        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.8rem;
        }

        img {
          margin-right: 0.5rem;

          &.call_icon {
            width: 2rem;
          }
        }
      }

      .description {
        color: #fff;
        font-size: 1.4rem;
        margin-top: 0.5rem;
        line-height: 1.8rem;
        height: 5rem;
        overflow: auto;
      }

      > .time_limit {
        color: #fff;
        font-size: 1.3rem;
        margin-top: 0.5rem;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.1rem;
        }
      }

      > .countdown {
        font-size: 1.3rem;
        margin-top: 0.5rem;
        @media (max-width: ${TABLET_WIDTH}px) {
          font-size: 1.1rem;
        }
      }
    }

    > .opacity {
      position: absolute;
      z-index: 1;
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    > .buttons {
      position: absolute;
      z-index: 10;
      width: 100%;
      bottom: 2rem;
      text-align: center;
      button {
        min-width: 10rem;
      }
    }
  }
  .tabs {
    background-color: #fff;

    @media (max-width: ${TABLET_WIDTH}px) {
      position: sticky;
      top: 0rem;
      border-bottom: 1px solid #eee;
      z-index: 10;
    }
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  &.gray {
    background-color: #D9D9D9;

    .tab {
      color: #000;
      &.selected {
        border-bottom: 2px solid #000;
      }
    }
  }

  .chat_header {

    @media (max-width: ${TABLET_WIDTH}px) {
      display: none;
    }
  }

  .expand {
    display: inline-block;
    background-color: #2680EB;
    height: 6rem;
    float: right;
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
    cursor: pointer;

    img {
      transform: rotateY(180deg);
    }

    p {
      color: white;
      font-weight: 600;
    }
  }

  .chat_container {
    height: calc(100vh - 40.5rem);

    .list_messages {
      height: calc(100vh - 40.5rem);
    }
  }

  .chat_lateral {
    box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;
  }
`;

export const ContentTab = styled.div`
  @media (max-width: ${TABLET_WIDTH}px) {
    padding: 0 1rem;
  }
  .content_layer {
    @media (min-width: ${TABLET_WIDTH}px) {
      width: calc(100% - 20rem);
      margin: 0 auto;
    }
  }

  &.with_chat {
    display: grid;
    grid-template-columns: 59% 39%;
    gap: 2rem;

    .content_wrapper {
      height: calc(100vh - 30rem);
      overflow: auto;
      padding-bottom: 3rem;
    }
  }
`;

export const ChatTab = styled.div`
  @media (max-width: ${TABLET_WIDTH}px) {
    .chat_wrapper {
      top: calc(10rem + env(safe-area-inset-top));
    }

    .chat_container {
      height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));

      .list_messages {
        height: calc(100vh - 14rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));
      }
    }
  }
`;

export const DocIframe = styled.iframe`
  width: ${props => props.width};
  height: ${props => props.height};
  margin-top: 1rem;
  border: 0px;
  background-color: #fff;
  margin-bottom: 2rem;

  @media (max-width: ${TABLET_WIDTH}px) {
    height: ${props => props.height};
  }
`;



// WEBPACK FOOTER //
// ./src/routes/CallForImpactHall/components/styles.js